import { render, staticRenderFns } from "./MarkBookUpload.vue?vue&type=template&id=15af51e2"
import script from "./MarkBookUpload.vue?vue&type=script&lang=js"
export * from "./MarkBookUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports